import styled from 'styled-components';

export const TextSector = styled.div`
  font-size: 14px;
  color: #004ba5;
`;
